import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Backdrop,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const NavigationButton = ({ onClick, disabled, direction }) => (
  <IconButton
    onClick={onClick}
    disabled={disabled}
  >
    {direction === 'back' ? (
      <ChevronLeftIcon
        sx={{ fontSize: 30, color: disabled ? '#c0c0c0' : 'black' }}
      />
    ) : (
      <ChevronRightIcon
        sx={{ fontSize: 30, color: disabled ? '#c0c0c0' : 'black' }}
      />
    )}
  </IconButton>
);

const CustomCalendar = ({
  viewType,
  setModalVisible,
  setSelectedMonthIndex,
  salesData = [],
  setSelectedYearIndex,
}) => {
  const [currentMonth, setCurrentMonth] = useState('');
  const [currentYear, setCurrentYear] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (salesData.length > 0) {
      const lastIndex = salesData.length - 1;
      const lastItem = salesData[lastIndex];

      if (viewType === 'year') {
        setCurrentYear(lastItem?.year || '');
        setSelectedYearIndex(lastIndex);
      } else {
        setCurrentMonth(lastItem?.month_name || '');
        setSelectedMonthIndex(lastIndex);
      }

      setCurrentIndex(lastIndex);
    }
  }, [salesData, viewType]);

  const goNext = () => {
    const newIndex = Math.min(currentIndex + 1, salesData.length - 1);
    setCurrentIndex(newIndex);
    updateSelectedData(newIndex);
  };

  const goBack = () => {
    const newIndex = Math.max(currentIndex - 1, 0);
    setCurrentIndex(newIndex);
    updateSelectedData(newIndex);
  };

  const updateSelectedData = (newIndex) => {
    const selectedData = salesData[newIndex];
    if (viewType === 'year') {
      setSelectedYearIndex(newIndex);
      setCurrentYear(selectedData?.year || '');
    } else {
      setSelectedMonthIndex(newIndex);
      setCurrentMonth(selectedData?.month_name || '');
    }
  };

  const isNextDisabled = currentIndex === salesData.length - 1;
  const isBackDisabled = currentIndex === 0;

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <NavigationButton
          onClick={goBack}
          disabled={isBackDisabled}
          direction='back'
        />
        <Typography
          variant='h6'
          sx={{ fontWeight: '500' }}
        >
          {viewType === 'year' ? currentYear : currentMonth}
        </Typography>
        <NavigationButton
          onClick={goNext}
          disabled={isNextDisabled}
          direction='next'
        />
      </Box>
    </Box>
  );
};

export default CustomCalendar;
